module.exports = "/static/assets/ababebe088315c098726bb98f6dacd65.jpg";